import React from "react";
import {useTranslation} from "react-i18next";
import {Box, Grid, Stack, Typography} from "@mui/material";
import {useFields, useMultiFarmFields} from "../../hooks/fieldsHooks";
import {getLatestCropId} from "../../utils/fieldUtils";
import {FieldTableCell} from "../fields/FieldTableCell";
import {FieldsTableHeader} from "../fields/FieldsTableHeader";
import {useCrops} from "../../hooks/cropsHooks";
import {getFieldAreaFormatted} from "../../utils/measureSystemUtils";
import {useMeasureSystemUtils} from "../../hooks/measureSystemUtilsHooks";

import {useCompany} from "../../hooks/companiesHooks";

interface FieldCompProps {
    farmId: string;
    companyId: string;
}

export const FarmEditFieldsTable: React.FC<FieldCompProps> = ({farmId, companyId}) => {
    const {t} = useTranslation();
    const msUtils = useMeasureSystemUtils();
    const fieldsState = useFields({companyId, orderId: undefined, farmId});
    const {cropsById} = useCrops();
    const _useMultiFarmFields = useMultiFarmFields({companyId});
    const company = useCompany();

    const _fields = company.isSuccess && company.data?.includeChildCompanies ? _useMultiFarmFields : fieldsState.items;

    const fieldHeaderItems = [
        t("fields.fields_table.header_field"),
        t("fields.fields_table.header_crop"),
        t("fields.fields_table.header_area"),
    ];
    const headerBreakpoints = [6, 3, 3];

    return (
        <div style={{}}>
            <FieldsTableHeader items={fieldHeaderItems} columns={12} breakpoints={headerBreakpoints} />

            <Box bgcolor="white" width="100%">
                {_fields.length > 0 ? (
                    _fields.map((field, index) => (
                        <Grid container sx={{p: 1}} key={index} alignItems="center" columns={12}>
                            <Grid item xs={headerBreakpoints[0]} zeroMinWidth>
                                <FieldTableCell color="primary">{field.name}</FieldTableCell>
                            </Grid>
                            <Grid item xs={headerBreakpoints[1]} zeroMinWidth>
                                <FieldTableCell>
                                    {getLatestCropId(field) ? cropsById[getLatestCropId(field)!].name : ""}
                                </FieldTableCell>
                            </Grid>
                            <Grid item xs={headerBreakpoints[2]}>
                                <FieldTableCell>
                                    {getFieldAreaFormatted(field, msUtils)} {msUtils.getAreaUnits()}.
                                </FieldTableCell>
                            </Grid>
                        </Grid>
                    ))
                ) : (
                    <Stack sx={{p: 1}} direction="row" justifyContent="center">
                        <Typography noWrap fontSize={14}>
                            {t("dialogs.farm_create.no_fields_message")}
                        </Typography>
                    </Stack>
                )}
            </Box>
        </div>
    );
};
